import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-infected-files-section',
    templateUrl: './infected-files-section.component.html',
    styleUrls: ['./infected-files-section.component.scss'],
    standalone: false
})
export class InfectedFilesSectionComponent {
  @Input() infectedFiles: string[] = [];

  @Output() refresh = new EventEmitter<void>();

  onRefreshClick(ev: Event): void {
    ev.preventDefault();
    this.refresh.emit();
  }
}
